import React, { useState, useEffect } from "react";
import { Box, TextField, Button, CircularProgress } from "@mui/material";
import api from "../../../services/api";
import StoreSelector from "./StoreSelector";

const InStorePaymentForm = ({
  onPaymentSuccess,
  setErrorMessage,
  canProceed,
  onBlockedAttempt,
}) => {
  const [receiptNumber, setReceiptNumber] = useState("");
  const [passcode, setPasscode] = useState("");
  const [stores, setStores] = useState([]);
  const [selectedStore, setSelectedStore] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    const fetchStores = async () => {
      try {
        const { data } = await api.get("/admin/stores/");
        setStores(data || []);
      } catch (error) {
        console.error("Failed to fetch stores:", error);
      }
    };
    fetchStores();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!canProceed) {
      onBlockedAttempt?.();
      return;
    }

    if (!receiptNumber.trim() || !passcode.trim() || !selectedStore) {
      setErrorMessage("All fields are required.");
      return;
    }

    setIsProcessing(true);
    setErrorMessage("");

    try {
      await onPaymentSuccess({
        type: "in-store",
        receiptNumber,
        passcode,
        store: selectedStore,
      });
    } catch (err) {
      console.error("Payment error:", err);
      setErrorMessage("Failed to process payment.");
    } finally {
      setIsProcessing(false);
    }
  };

  const isFormValid = () =>
    receiptNumber.trim() && passcode.trim() && selectedStore;

  return (
    <form onSubmit={handleSubmit}>
      <Box sx={{ mb: 3 }}>
        <TextField
          label="POS Receipt Number"
          value={receiptNumber}
          onChange={(e) => setReceiptNumber(e.target.value)}
          fullWidth
          sx={{ mb: 2 }}
          required
        />

        <TextField
          label="Employee Passcode"
          value={passcode}
          onChange={(e) => setPasscode(e.target.value)}
          fullWidth
          type="password"
          sx={{ mb: 2 }}
          required
        />

        <StoreSelector
          stores={stores}
          selectedStore={selectedStore}
          setSelectedStore={setSelectedStore}
        />
      </Box>

      <Button
        type="submit"
        fullWidth
        size="large"
        variant="contained"
        color="primary"
        disabled={!isFormValid() || isProcessing}
        startIcon={
          isProcessing ? <CircularProgress size={18} color="inherit" /> : null
        }>
        {isProcessing ? "Processing..." : "Confirm In-Store Payment"}
      </Button>
    </form>
  );
};

export default InStorePaymentForm;
